import { render, staticRenderFns } from "./HeaderDots.vue?vue&type=template&id=bf65eca4&"
import script from "./HeaderDots.vue?vue&type=script&lang=js&"
export * from "./HeaderDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports